module.exports = __webpack_public_path__ + "b97b8fa436539c475aa2bf7be57234a7.svg";